import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import greetingSound from "../voice/greeting.wav";
import { useToken } from "./TokenContext"; // contextの場所に応じて調整
import miochan from "../img/miochan.png";
import Header from "./InputHeader";
import Footer from "./Footer";
import "../css/nameinput.css";

function NameInput() {
  const [name, setName] = useState("");
  const [zipcode, setZipcode] = useState("");
  const [address, setAddress] = useState("");
  const [agree, setAgree] = useState(false);
  const audioRef = useRef(null);
  const navigate = useNavigate();
  const { setUserName, userRole } = useToken(); // ✅ userRole を取得

  useEffect(() => {
    const initialName = localStorage.getItem("userName") || "";
    setName(initialName);

    if (audioRef.current) {
      audioRef.current.pause();
    }
    audioRef.current = new Audio(greetingSound);
    audioRef.current.play().catch((error) => {
      console.error("音声再生に失敗しました:", error);
    });

    return () => {
      if (audioRef.current) audioRef.current.pause();
    };
  }, []);

  const checkTokenExpiry = () => {
    const expiry = localStorage.getItem("accessExpiry");
    if (!expiry) return;

    const now = Date.now();
    const expiryTime = parseInt(expiry, 10);
    const remainingDays = Math.ceil((expiryTime - now) / (1000 * 60 * 60 * 24));
    if (remainingDays > 0 && remainingDays <= 14) {
      alert(`このトークンはあと ${remainingDays} 日で失効します`);
    }
  };

  const handleZipSearch = async () => {
    if (!zipcode) return;
    try {
      const res = await fetch(`https://zipcloud.ibsnet.co.jp/api/search?zipcode=${zipcode}`);
      const data = await res.json();
      if (data.results) {
        const r = data.results[0];
        setAddress(`${r.address1}${r.address2}${r.address3}`);
      } else {
        setAddress("住所が見つかりませんでした");
      }
    } catch (err) {
      setAddress("検索エラー");
    }
  };

  const handleStart = () => {
    if (!name.trim()) {
      alert("名前を入力してください");
      return;
    }
    if (!agree) {
      alert("プライバシーポリシーに同意してください");
      return;
    }

    localStorage.setItem("userName", name);
    localStorage.setItem("userAddress", address);
    setUserName(name);
    checkTokenExpiry();
    navigate("/Portal");
  };

  return (
    <div className="page-wrapper">
      <Header />
      <main>
        <div className="nameinput-page">
          <div className="form-and-character">
            <div className="form-area">
              <p>お名前を入力してください【必須】</p>
              <input
                type="text"
                value={name}
                placeholder="名前を入力"
                onChange={(e) => setName(e.target.value)}
              />

              <label htmlFor="zipcode">居住地の郵便番号（ハイフンなし）</label>
              <div className="zip-search-row">
                <input
                  id="zipcode"
                  type="text"
                  value={zipcode}
                  maxLength={7}
                  placeholder="例：1000001"
                  onChange={(e) => setZipcode(e.target.value)}
                />
                <button onClick={handleZipSearch}>市区町村を検索</button>
              </div>
              {address && <p className="address-result">居住地: {address}</p>}

              <div className="privacy-check">
                <input
                  type="checkbox"
                  id="agree"
                  checked={agree}
                  onChange={(e) => setAgree(e.target.checked)}
                />
                <label htmlFor="agree">
                  <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">プライバシーポリシー</a>
                  に同意します
                </label>
              </div>

              <button className="start-button" onClick={handleStart} disabled={!agree}>
                はじめる
              </button>

              {/* ✅ 指導員以上向けボタン */}
              {userRole >= 4 && (
                <button
                  className="admin-button"
                  onClick={() => navigate("/Personality-check-4-admin")}
                  style={{ marginTop: "20px", backgroundColor: "#444", color: "#fff" }}
                >
                  指導員専用：個別支援アシスタントページ
                </button>
              )}
            </div>

            <div className="character-area">
              <img src={miochan} alt="miochan" />
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default NameInput;
